import { render, staticRenderFns } from "./BookingStatusHistory.vue?vue&type=template&id=bc1dd2e2&scoped=true&"
import script from "./BookingStatusHistory.vue?vue&type=script&lang=ts&"
export * from "./BookingStatusHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BookingStatusHistory.vue?vue&type=style&index=0&id=bc1dd2e2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1dd2e2",
  null
  
)

export default component.exports